import React, { useState, useEffect } from 'react';
import BackButton from '../_Shared/BackButton';
import { Form, Col, InputGroup } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { Formik } from 'formik';
import * as Yup from 'yup';
import { numberValidation, monthValidation } from '../_Shared/Validation';
import result from '../_Shared/Result';
import formulaDefinition from '../_Shared/FormulaDefinition';

function TotalPartsDepartmentGrossPercentSales() {
    const [grossProfit, setGrossProfit] = useState(0);
    const [sales, setSales] = useState(0);
    const [total, setTotal] = useState(0);
    const history = useHistory();

    useEffect(() => {
        setTotal((parseInt(grossProfit) / parseInt(sales)) * 100);
    }, [grossProfit, sales])

    function clickResult() {
        history.push(
            {
                pathname: `/totalpartsdepartmentgrosspercentsalesresult?total=${parseFloat(total).toFixed(2)}`
            })
    }

    const validationSchema = Yup.object({
        grossProfit: numberValidation,
        sales: numberValidation
    });

    const def = <span>Total Parts Department Gross Profit &#247; Total Parts Department Sales</span>;

    return (
        <Formik
            initialValues={{ grossProfit: "", sales: "" }}
            validationSchema={validationSchema}
            onSubmit={e => {
                clickResult();
            }}
        >
            {({ handleSubmit, handleChange, values, errors }) => (

                <div className="container">
                    <main role="main">
                        <div className="jumbotron ">
                            <div className="col-sm-10 mx-auto">
                                <BackButton />
                                <h2 className="text-center">Total Parts Department Gross Percent Sales</h2>

                                {formulaDefinition(def)}

                                <Form onSubmit={handleSubmit}>
                                    <Form.Row>

                                        <Form.Group as={Col} md="12" mb="3" controlId="grossProfit">
                                            <Form.Label>Total Parts Department Gross Profit</Form.Label>
                                            <InputGroup className="mb-2"><InputGroup.Prepend> <InputGroup.Text>$</InputGroup.Text></InputGroup.Prepend>
                                                <Form.Control size="lg" type="number" name="grossProfit" value={values.grossProfit} isInvalid={!!errors.grossProfit}
                                                onChange={e => { handleChange(e); setGrossProfit(e.target.value) }} />
                                            <Form.Control.Feedback type="invalid">{errors.grossProfit}</Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>

                                        <Form.Group as={Col} md="12" mb="3" controlId="sales">
                                            <Form.Label>Total Parts Department Sales</Form.Label>
                                            <InputGroup className="mb-2"><InputGroup.Prepend> <InputGroup.Text>$</InputGroup.Text></InputGroup.Prepend>
                                                <Form.Control size="lg" type="number" name="sales" value={values.sales} isInvalid={!!errors.sales}
                                                onChange={e => { handleChange(e); setSales(e.target.value) }} />
                                            <Form.Control.Feedback type="invalid">{errors.sales}</Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>

                                    </Form.Row>
                                    <p className="pb-5">
                                        <button className="btn-lg btn-primary btn-block" type="submit">Calculate &raquo;</button>
                                    </p>
                                </Form>
                            </div>
                        </div>
                    </main>
                </div>
            )}
        </Formik>
    );

}

function TotalPartsDepartmentGrossPercentSalesResult() {
    const urlParams = new URLSearchParams(window.location.search);
    const title = "Total Parts Department Gross Percent Sales";
    const total = urlParams.get('total') + '%';
    const ratio = "40%";

    const cond = parseFloat(total) >= 40;

    return (
        <div>
            {result(title, total, ratio, cond)}
        </div>
    );
}


export {
    TotalPartsDepartmentGrossPercentSales,
    TotalPartsDepartmentGrossPercentSalesResult
}